import { Icon } from "components";
import { LOCK, PLUS } from "icons";
import { Card, CardContent } from "ui/components/card";
import { cn } from "utils";
import { COMMON_CLASSES_FOR_CARD } from "./utils";
import { Link } from "react-router-dom";

export default function LockCard({ onClick }) {
  return (
    <Card
      className={cn(
        COMMON_CLASSES_FOR_CARD,
        "border-dashed border-2 cursor-pointer"
      )}
      onClick={onClick}
    >
      <CardContent className="flex flex-col gap-3 w-full h-full justify-center items-center">
        <div className="size-9 flex justify-center items-center  rounded-full bg-red-50 flex-none">
          <Icon icon={LOCK} className="text-red-900" />
        </div>
        <span className="text-sm font-semibold text-foreground">Locked</span>
        <p className="text-muted-foreground text-center text-xs">
          This log is over 7 days old and the <br /> timesheet is now locked for
          changes.
          <br /> Click to unlock.
        </p>
      </CardContent>
    </Card>
  );
}
